import { render, staticRenderFns } from "./default.vue?vue&type=template&id=138a6959&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=138a6959&prod&lang=css&"
import style1 from "./default.vue?vue&type=style&index=1&id=138a6959&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SidebarFuncionario: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/sidebar/SidebarFuncionario.vue').default,SidebarCiudadano: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/sidebar/SidebarCiudadano.vue').default,PublicFooter: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/public/Footer.vue').default})
